import React from 'react';

import SunAnimation from '../LoadingAnimations/sun';
import SnowAnimation from '../LoadingAnimations/snowing';
import Worm from '../LoadingAnimations/worm';
import SpinningCircle from '../LoadingAnimations/SpinningCircle';
import AspenAnimation from "../LoadingAnimations/aspenAnimation";

import SEO from '../../../components/Seo';

import { getSystemSettings } from '../../../utils/SettingsRetriever';
import IntlMessage from '../../../LocaleEngine';

import './index.scss';

export default function SearchingScreen(props) {
    const configuration = getSystemSettings();

    let logo = 'https://ik.imagekit.io/spotlio/dummy-px_nVIPQQD2f.png';
    if(configuration && configuration.assets && configuration.assets.loading && configuration.assets.loading.logo) {
        logo = configuration.assets.loading.logo;
    }

    const defaultMessages = {
        neutral: {
            neutral: "loadingscreen.messages.default.neutral.neutral",
            loading: "loadingscreen.messages.default.neutral.loading",
            noresults: "loadingscreen.messages.default.neutral.noresults"
        },
        lodging: {
            loading: "loadingscreen.messages.default.lodging.loading",
            noresults: "loadingscreen.messages.default.lodging.noresults"
        },
        merchandise: {
            loading: "loadingscreen.messages.default.merchandise.loading",
            noresults: "loadingscreen.messages.default.merchandise.noresults",
        },
        activities: {
            loading: "loadingscreen.messages.default.activities.loading",
            noresults: "loadingscreen.messages.default.activities.noresults",
        },
        shuttle: {
            loading: "loadingscreen.messages.default.shuttle.loading",
            noresults: "loadingscreen.messages.default.shuttle.noresults",
        },
        rentals: {
            loading: "loadingscreen.messages.default.rentals.loading",
            noresults: "loadingscreen.messages.default.rentals.noresults",
        },
        lessons: {
            loading: "loadingscreen.messages.default.lessons.loading",
            noresults: "loadingscreen.messages.default.lessons.noresults",
        },
        'lift-tickets': {
            loading: "loadingscreen.messages.default.lift-tickets.loading",
            noresults: "loadingscreen.messages.default.lift-tickets.noresults",
        },
        'winter-lift-tickets': {
            loading: "loadingscreen.messages.default.winter-lift-tickets.loading",
            noresults: "loadingscreen.messages.default.winter-lift-tickets.noresults",
        },
        packages: {
            loading: "loadingscreen.messages.default.packages.loading",
            noresults: "loadingscreen.messages.default.packages.noresults",
        },
        package: {
            loading: "loadingscreen.messages.default.packages.loading",
            noresults: "loadingscreen.messages.default.packages.noresults",
        },
        cart: {
            loading: "loadingscreen.messages.default.cart.loading",
            noresults: "loadingscreen.messages.default.cart.noresults"
        },
        gondola: {
            loading: "loadingscreen.messages.default.gondola.loading",
            noresults: "loadingscreen.messages.default.gondola.noresults"
        },
        biking: {
            loading: "loadingscreen.messages.default.biking.loading",
            noresults: "loadingscreen.messages.default.biking.noresults"
        },
        'water-sports': {
            loading: "loadingscreen.messages.default.water-sports.loading",
            noresults: "loadingscreen.messages.default.water-sports.noresults"
        },
        flights: {
            loading: "loadingscreen.messages.default.flights.loading",
            noresults: "loadingscreen.messages.default.flights.noresults"
        },
        'car-rental': {
            loading: "loadingscreen.messages.default.car-rental.loading",
            noresults: "loadingscreen.messages.default.car-rental.noresults"
        }
    };

    let section = props.section;
    if (section === '' || typeof section === 'undefined') section = 'neutral';

    let mode = props.mode;
    if (mode === '' || typeof mode === 'undefined') mode = 'neutral';

    let message = props.message
    if (!message || message === '' || typeof message === 'undefined') {
        if (!defaultMessages[section] || (defaultMessages[section] && !defaultMessages[section][mode])) {
            message = <IntlMessage id={defaultMessages.neutral.neutral} />
        } else {
            message = <IntlMessage id={defaultMessages[section][mode]} />;
        }
    }
    

    let animation = false;
    if(! !configuration.app.animation) animation = configuration.app.animation;

    if(animation === 'snow'){
        animation = <SnowAnimation />;
    }

    if(animation === 'sun'){
        animation = <SunAnimation />;
    }

    if(animation === 'worm'){
        animation = <Worm />;
    }

    if (props.section === 'error'){
        animation = null
    }

    if (mode === "noresults"){
        animation = null
    }

    if (animation === "aspen"){
        return (
            <React.Fragment>
                <div className="searchingScreenBackground" />
                <div className="searchingScreen" aria-hidden="true">
                    <SEO title="Loading..." />
                    <div className="innerBanner spinningCircle">
                        <AspenAnimation />
                        <h1>{message}</h1>
                    </div>
                </div>
            </React.Fragment>
        )
    }
    
    if (animation === 'spinning_circle') {
        return (
            <React.Fragment>
                <div className="searchingScreenBackground" />
                <div className="searchingScreen" aria-hidden="true">
                    <SEO title="Loading..." />
                    <div className="innerBanner spinningCircle">
                        <SpinningCircle message={message} logo={logo} />
                        <h1>{message}</h1>
                    </div>
                </div>
            </React.Fragment>
        )
    }
    
    return (
        <React.Fragment>
            <div className="searchingScreenBackground" />
            <div className="searchingScreen" aria-hidden="true">
                <SEO title="Loading..." />
                <div className="innerBanner">
                    {animation}
                    <img src={logo} alt={configuration.head.title} />
                    {
                        typeof message === "string" 
                        ? <h1 dangerouslySetInnerHTML={{ __html: message }} />
                        : <h1>{message}</h1>
                    }
                </div>
            </div>
        </React.Fragment>
    )
}
